import { Selector, State } from "./types";
import { id, list, project, task, retrieveTaskError } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    getRetrieveTaskError(taskId) {
      const req = getState().find(({ task }) => task.uuid === taskId);

      return req ? req.error : retrieveTaskError;
    },
    getTask(taskId) {
      const res = getState().find(({ id }) => id === taskId);

      return res
        ? res.task
        : {
            ...task,
            uuid: taskId,
            list: { ...list, uuid: id },
            project: { ...project, uuid: id },
            error: { ...retrieveTaskError },
          };
    },
    isTaskRetrievalRequestFailure(taskId) {
      const res = getState().find(({ id }) => id === taskId);

      return res ? res.request.isFailure : true;
    },
    isTaskRetrievalRequestPending(taskId) {
      const res = getState().find(({ id }) => id === taskId);

      return res ? res.request.isPending : false;
    },
    isTaskRetrievalRequestSuccess(taskId) {
      const res = getState().find(({ id }) => id === taskId);

      return res ? res.request.isSuccessful : false;
    },
    hasRetrievedTask(taskId) {
      const res = getState().find(({ id }) => id === taskId);

      return res ? res.request.isSuccessful || res.request.isFailure : false;
    },
  };
}

export { createSelector };
